import "core-js/modules/es.array.find-index.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "jiao-interact"
};
var _hoisted_2 = {
  class: "jiao-interact-tab"
};
var _hoisted_3 = {
  class: "jiao-interact-content"
};
import { computed, ref } from 'vue';
import SubTab from '../../Components/SubTab.vue';
import Resource from './Involved.vue';
import Show from './Play.vue';
export default {
  __name: 'index',
  setup: function setup(__props) {
    var tabs = [{
      name: '参与数据',
      value: 1,
      component: Resource,
      exist: true
    }, {
      name: '互动数据',
      value: 2,
      component: Show,
      exist: true
    }];
    var defaultIndex = ref(1);
    var currentComponent = computed(function () {
      var index = tabs.findIndex(function (item) {
        return item.value === defaultIndex.value;
      });
      return tabs[index].component;
    });
    var handleChangeTab = function handleChangeTab(item) {
      defaultIndex.value = item.value;
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(SubTab, {
        tabs: tabs,
        "default-index": defaultIndex.value,
        onChange: handleChangeTab
      }, null, 8, ["default-index"])]), _createElementVNode("div", _hoisted_3, [(_openBlock(), _createBlock(_resolveDynamicComponent(currentComponent.value)))])]);
    };
  }
};